import React, { ReactElement } from 'react'

type BasketIntroProps = {
  content: string;
}

const BasketIntro = ({ content }: BasketIntroProps): ReactElement => (
  <div className="basket-intro" dangerouslySetInnerHTML={ { __html: content } }></div>
)

export default BasketIntro
